import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, FormControl } from '@mui/material';
import FieldError from './FieldError.js';
import FieldLabel from './FieldLabel.js';
import { getCssCharacterWidth } from '../../modules/styling/utils.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _excluded = ["renderReadOnly", "width", "fluid", "label", "labelProps", "fixedLabel", "actions", "errors", "animateErrors", "className", "sx", "children"];
var componentField = createComponentSlot({
  name: "CinForm",
  slot: "Field",
  skipForwardProps: ["width"]
});
var FieldBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var renderReadOnly = _ref.renderReadOnly;
      _ref.width;
      var fluid = _ref.fluid,
      label = _ref.label,
      labelProps = _ref.labelProps;
      _ref.fixedLabel;
      var actions = _ref.actions,
      errors = _ref.errors,
      animateErrors = _ref.animateErrors,
      className = _ref.className;
      _ref.sx;
      var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var readOnly = typeof renderReadOnly === "function";
  return /*#__PURE__*/React.createElement(FormControl, _extends({
    error: errors && errors.length > 0
  }, otherProps, {
    className: classnames(componentField.className, className, {
      fluid: fluid
    }),
    ref: ref
  }), label && /*#__PURE__*/React.createElement(FieldLabel, labelProps, label), readOnly ? /*#__PURE__*/React.createElement("div", {
    className: "read-only"
  }, renderReadOnly()) : children, actions && /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, actions), errors && /*#__PURE__*/React.createElement(FieldError, {
    errors: errors,
    animate: animateErrors
  }));
});
/**
 * A container for a form field with an optional label and errors
 */

FieldBase.propTypes = {
  renderReadOnly: propTypes.oneOfType([propTypes.bool, propTypes.func]),
  width: propTypes.oneOfType([propTypes.number, propTypes.string, propTypes.oneOf([null])]),
  fluid: propTypes.bool,
  label: propTypes.node,
  labelProps: propTypes.any,
  fixedLabel: propTypes.bool,
  actions: propTypes.node,
  errors: propTypes.arrayOf(propTypes.string),
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  className: propTypes.string,
  sx: propTypes.any
};
var Field = styled(FieldBase, _objectSpread2(_objectSpread2({}, componentField.styledOptions), {}, {
  skipVariantsResolver: true
}))(function (_ref2) {
  var theme = _ref2.theme,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 30 : _ref2$width,
      fluid = _ref2.fluid;
  return {
    display: "block",
    width: fluid ? "100%" : width !== null ? getCssCharacterWidth(width) : undefined,
    marginBottom: theme.spacing(3),
    "&:last-child": {
      marginBottom: 0
    },
    "> .MuiInputBase-root, > .MuiTextField-root": {
      width: "100%"
    }
  };
});
var Field$1 = Field;

export { Field$1 as default };
